import { useMemo } from 'react'
import { ColumnDef } from '@tanstack/react-table'
import { Checkbox } from '@/components/shadcn/checkbox'

export function useTableColumns<TData, TValue>(columns: ColumnDef<TData, TValue>[], isSelectionEnabled: boolean) {
  return useMemo(() => {
    if (!isSelectionEnabled) return columns

    const selectionColumn: ColumnDef<TData, TValue> = {
      id: 'select',
      size: 50,
      header: ({ table }) => (
        <Checkbox
          checked={table.getIsAllPageRowsSelected() || (table.getIsSomePageRowsSelected() && 'indeterminate')}
          onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
          aria-label="Select all"
          className="translate-y-[2px]"
        />
      ),
      cell: ({ row }) => (
        <Checkbox
          checked={row.getIsSelected()}
          onCheckedChange={(value) => row.toggleSelected(!!value)}
          aria-label="Select row"
          className="translate-y-[2px]"
        />
      ),
      enableSorting: false,
      enableHiding: false,
    }

    return [selectionColumn, ...columns]
  }, [columns, isSelectionEnabled])
}
